export default __webpack_public_path__ + "static/media/red-zigzag.3de76331.svg";